import React from 'react';

import RoomListPanelsView from './RoomListPanels.view';

const RoomListPanels: React.FC<{}> = () => {
    return <RoomListPanelsView />;
};
export default RoomListPanels;
